import { IonAvatar, IonButton, IonImg } from "@ionic/react";
import { useAuthStore } from "../stores/auth.store";
import { useBotsStore } from "../stores/bots.store";
import { useEffect, useState } from "react";
import Confetti from "react-confetti";
import useWindowDimensions from "../hooks/useWindowDimensions";
import LobbyPlacings from "./LobbyPlacings";
import SaveStrategyButton from "./SaveStrategyButton";
import FullSummary from "./FullSummary";

interface Props {
  lobby: any;
  completeChallenge: (exit?: boolean) => void;
}

const ChallengeSummary: React.FC<Props> = ({ lobby, completeChallenge }) => {
  const { height, width } = useWindowDimensions();
  let userId = useAuthStore(state => state.user?.uid);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [instanceId, setInstanceId] = useState(
    Math.floor(Math.random() * 1000000000)
  );
  let botSnapshot =
    lobby?.standings?.find((s: any) => s.user === userId) ||
    (lobby?.standings && lobby?.standings[0]);
  const bot = useBotsStore(state =>
    state.bots.find((b: any) => b.id === botSnapshot?.botId)
  );

  const earnings =
    bot?.payOut +
    (lobby?.prizePayout?.find((p: any) => p.userId === userId)?.quantity || 0);

  const rank = lobby?.standings?.findIndex((s: any) => s.botId === bot?.id) + 1;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    if (bot && rank === 1) {
      setShowConfetti(true);
      setTimeout(() => {
        setShowConfetti(false);
      }, 6000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rank]);

  if (!bot) return null;
  return (
    <>
      {showConfetti && <Confetti width={width} height={height} />}
      <div className="flex flex-col items-center bg-primary-90">
        <div className="pt-24 w-full bg-blue-500 bg-gradient-to-b from-primary-90 to-primary-80"></div>
        <div className="flex flex-col items-center">
          <IonAvatar className="h-32 w-32 p-4 -mt-16 bg-primary-90">
            <IonImg src={bot?.img} />
            <span className="absolute -mt-20 px-1 rounded-full bg-primary-90 text-yellow-400">
              {rank}
            </span>
          </IonAvatar>
          <div className="text-2xl font-semibold text-primary-40 capitalize">
            {bot?.name}
          </div>
          <div className="text-primary-40 text-sm">{lobby?.startDate}</div>
        </div>
        <div className="w-full px-4">
          <div className="flex justify-between items-center w-full pl-1 text-lg my-2">
            <span>Bot performance</span>
            <SaveStrategyButton bot={bot} />
          </div>
          <div className="flex justify-between gap-x-2">
            <div className="flex flex-col bg-primary-80 items-center text-primary-50 p-4 gap-2 rounded-lg w-1/3">
              <div className="text-white text-xs">RANK</div>
              <div className="text-xl font-semibold">{rank}</div>
              <div className="text-sm">[ {lobby?.bots?.length} BOTS ]</div>
            </div>
            <div className="flex flex-col bg-primary-80 items-center text-primary-50 py-4 px-2 gap-2 rounded-lg w-1/3">
              <div className="text-white text-xs">TOTAL PROFIT</div>
              <div
                className={`text-xl font-semibold ${
                  bot?.profit &&
                  (bot.profit < 0 ? "text-red-400" : "text-green-400")
                }`}
              >
                {bot?.profit.toFixed(2)}%
              </div>
              <div className="text-sm">[ {lobby?.bots?.length} BOTS ]</div>
            </div>
            <div className="flex flex-col bg-primary-80 items-center text-primary-50 p-4 gap-2 rounded-lg w-1/3">
              <div className="text-white text-xs">EARNINGS</div>
              <div className="text-xl font-semibold">{earnings.toFixed(2)}</div>
              <div className="text-sm">QUOCOIN</div>
            </div>
          </div>
        </div>
        <div className="px-2 w-screen">
          <LobbyPlacings lobby={lobby} instanceId={instanceId} />
        </div>
      </div>
      <div className="flex w-screen px-2">
        <IonButton
          fill="outline"
          className="rounded w-full h-12 font-semibold"
          routerLink="/dashboard"
          onClick={() => completeChallenge()}
        >
          Done
        </IonButton>
        <FullSummary lobby={lobby} />
      </div>
      {/* <div className="flex w-screen px-2">
        <IonButton
          fill="clear"
          className="rounded w-full h-12 font-semibold"
          routerLink={`/lobbies/${lobby?.id}`}
        >
          View Lobby
        </IonButton>
      </div> */}
    </>
  );
};

export default ChallengeSummary;
